/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../libs/Context';
import { Image } from '../../../libs/CustomHooks/Image';
const GroupAudioCallPartipateList = (props) =>
{
	const { language } = useContext(LanguageContext);

	const userData = useSelector((state:any) => state?.mysession?.session);

	const selfData:any = props?.roomMembers?.find((each:any) => each?.userId === userData?.userId);

	return (
		<div className='flexMinHeightCol pdngXS scrollY'>
			<div className='flexRow alignCntr pdngXXS'>
				<div className='flexAutoRow pdngHXS'>
					<div className='imgAvatarMD brdrRadius50'>
						<div className=' imgAvatarMD brdrBlackSM brdrRadius50'>
							<Image src={selfData?.profileImage ? selfData?.profileImage : '/images/icons/defaultUser.svg'} className='brdrRadius50' fallback={<img src='/images/icons/defaultUser.svg' alt='fallback' className='brdrRadius50'/>} />
						</div>
					</div>
				</div>
				<div className='flexMinWidthRow pdngHXS'>
					<span className='whiteLightTxt capitalTxt'>{language?.you}</span>
				</div>
			</div>
			{props?.roomMembers?.map((item) =>
				(<div className='flexRow alignCntr pdngXXS' key={item?.userId}>
					{item?.userId !== userData?.userId &&
					<><div className='flexAutoRow pdngHXS'>
						<div className='imgAvatarSM brdrRadius50'>
							<div className='imgAvatarSM brdrBlackSM brdrRadius50'>
								<Image src={item?.profileImage || '/images/icons/defaultUser.svg'} alt='user' className='brdrRadius50' fallback={<img src='/images/icons/defaultUser.svg' alt='fallback' className='brdrRadius50'/>} />
							</div>
						</div>
					</div><div className='flexAutoRow pdngHXS'>
						<span className='whiteLightTxt capitalTxt'>{item?.name}</span>
					</div></>}
				</div>))}
		</div>
	);
};

export default GroupAudioCallPartipateList;
